

















































































import { Component, Vue } from 'vue-property-decorator';
import Decimal, {isDecimal} from '@/utils/decimal';

@Component({})
export default class UITestingTables extends Vue {
  private amount1 = new Decimal(0);

  // returns a class highlighting the cell based on how far away from zero it is
  private warnDiffFromZero(amount: Decimal) {
    // eslint-disable-next-line no-console
    console.log(amount, isDecimal(amount));
    if (amount.greaterThan(20) || amount.lessThan(-20)) {
      return 'warn major';
    } else if (amount.greaterThan(5) || amount.lessThan(-5)) {
      return 'warn minor';
    } else {
      return '';
    }
  }
}
